// disable console.log for deployment
if (location.host.substring(0, 3) == "www" || 
    location.host.substring(0, 2) == "qa") 
{
    window.console.log = function () { };
    window.console.warn = function () { };
    window.console.error = function () { };
}